import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// 以下为语言包单独设置的场景，单独设置时语言包需单独引入
const messages = {
    'en': require('./i18n/en.json'), // 英文语言包
    'zh': require('./i18n/zh.json'), // 中文语言包
    'he': require('./i18n/he.json'), // 希伯来语言包
    'vi': require('./i18n/vi.json'),
    // 'fr': require('./i18n/fr'),   // 法语语言包
    // 'sp': require('./i18n/sp'),   // 西班牙语言包
}

// 最后 export default，这一步肯定要写的。
export default new VueI18n({
    locale: 'en', // set locale 默认显示英文
    fallbackLocale: 'en', 
    messages,
    silentTranslationWarn: true,
})


// WEBPACK FOOTER //
// ./src/utils/i18n.js